import Mutation from '@/view/Mutation/ListeMutation'
import DetailMutation from '@/view/Mutation/DetailMutation'

const TABLE_BREADCRUMB = {
  code: 'mutation.list.title',
  link: {
    name: 'mutation/liste',
  },
}

export default [
  {
    path: '/mutation',
    name: 'mutation/liste',
    component: Mutation,
    meta: {
      auth: 'hasRole(ROLE_CORRESPONDANT)',
      breadcrumb: () => [TABLE_BREADCRUMB],
    },
  },
  {
    path: '/mutation/:id',
    name: 'mutation/detail',
    component: DetailMutation,
    meta: {
      auth: 'hasRole(ROLE_CORRESPONDANT)',
      breadcrumb: () => [
        TABLE_BREADCRUMB,
        {
          code: 'mutation.overview',
        },
      ],
    },
  },
]
